<template>
  <div id="applicationManager">
    <!-- Header -->
    <div
      :class="{ 'header-page-long' : !is_sidebar_minimized }"
      class="header-page"
    >
      <div class="d-flex justify-content-between align-items-center">
        <div class="d-flex align-items-center">
          <img
            class="back-to-list"
            src="@/assets/icon/arrow-left.svg"
            @click="$router.push('/application-manager')"
          >
          <div
            v-if="isLoading"
            class="skeleton-box"
            style="width: 100px; height: 30px; margin-bottom: 0 !important;"
          />
          <h3
            v-else
            class="application-name"
          >
            {{ application_detail.name }}
          </h3>
        </div>
        <i
          id="popover-config-menu"
          class="fa fa-ellipsis-v fa-lg popover-config"
        />
      </div>

      <!-- Tabs -->
      <div class="tabs">
        <div
          v-for="tab in tabs"
          :key="tab.id"
          :class="{ 'tab-active': tabActive === tab.id }"
          class="tab-list"
          @click="changeTab(tab.id)"
        >
          {{ tab.label }}
        </div>
      </div>
    </div>

    <div
      :class="{ 'wrap-content-long' : !is_sidebar_minimized }"
      class="wrap-content bg-canvas"
    >
      <j-component-library v-if="tabActive === 'layout'" />

      <!-- Content -->
      <div class="application-content">
        <!-- General Tab -->
        <j-general-tab v-if="tabActive === 'general'" />

        <!-- Layout Tab -->
        <j-layout-tab v-else-if="tabActive === 'layout'" />

        <!-- Data Source Tab -->
        <j-data-source-tab v-else-if="tabActive === 'data-source'" />

        <!-- Experience Manager Tab -->
        <j-exp-manager-tab v-else-if="tabActive === 'experience-manager'" />

        <!-- Visual Programming Tab -->
        <j-visprog-tab v-else-if="tabActive === 'visual-programming'" />

        <!-- Analytic Dashboard Tab -->
        <j-analytic-tab v-else-if="tabActive === 'analytic-dashboard'" />

        <!-- Variables Tab -->
        <j-variables-tab v-else-if="tabActive === 'variables'" />

        <!-- API Manager Tab -->
        <j-api-manager-tab v-else-if="tabActive === 'api-manager'" />
      </div>
    </div>

    <!-- Popover -->
    <b-popover
      ref="configPopoverRef"
      target="popover-config-menu"
      placement="left"
    >
      <div
        class="form-ui-opt"
        @click="deleteApp"
      >
        Delete Application
      </div>
      <div
        class="form-ui-opt"
        @click="backToV1"
      >
        Back to V1
      </div>
    </b-popover>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex';
// Components
import jComponentLibrary from '@/views/application-manager/detail/jComponentLibrary';
import jAnalyticTab from '@/views/application-manager/detail/app-tabs/jAnalyticTab';
import jApiManagerTab from '@/views/application-manager/detail/app-tabs/jApiManagerTab';
import jDataSourceTab from '@/views/application-manager/detail/app-tabs/jDataSourceTab';
import jExpManagerTab from '@/views/application-manager/detail/app-tabs/jExpManagerTab';
import jGeneralTab from '@/views/application-manager/detail/app-tabs/jGeneralTab';
import jLayoutTab from '@/views/application-manager/detail/app-tabs/jLayoutTab';
import jVariablesTab from '@/views/application-manager/detail/app-tabs/jVariablesTab';
import jVisprogTab from '@/views/application-manager/detail/app-tabs/jVisprogTab';

export default {
  components: {
    jComponentLibrary,
    jAnalyticTab,
    jApiManagerTab,
    jDataSourceTab,
    jExpManagerTab,
    jGeneralTab,
    jLayoutTab,
    jVariablesTab,
    jVisprogTab,
  },

  data() {
    return {
      isLoading: true,
      tabs: [
        { id: 'general', label: 'SETTINGS' },
        { id: 'layout', label: 'LAYOUT' },
        // { id: 'data-source', label: 'DATA SOURCE' },
        // { id: 'experience-manager', label: 'EXPERIENCE MANAGER' },
        // { id: 'visual-programming', label: 'VISUAL PROGRAMMING' },
        // { id: 'analytic-dashboard', label: 'ANALYTIC DASHBOARD' },
        // { id: 'variables', label: 'VARIABLES' },
        // { id: 'api-manager', label: 'API MANAGER' },
      ],
    };
  },

  computed: {
    ...mapState('jStoreSetting', ['is_sidebar_minimized', 'application_detail']),

    tabActive() {
      return this.$route.params.tab;
    },
  },

  watch: {
    application_detail(val) {
      if (val) this.isLoading = false;
    },
  },

  created() {
    this.getApplicationDetail();
    setTimeout(() => {
      this.setSidebarMinimized(false);
    }, 300);
  },

  methods: {
    ...mapMutations('jStoreSetting', ['setSidebarMinimized']),
    ...mapActions('jStoreSetting', ['actionGetApplicationDetail', 'actionDeleteApplication']),

    async getApplicationDetail() {
      const applicationId = this.$route.params.applicationId;
      const param = {
        params: {
          page: 1,
          limit: 0,
          column: 'id',
          sort: 'asc',
          query: '',
          query_type: '',
        },
      };
      await this.actionGetApplicationDetail({ applicationId, param });
    },

    changeTab(tab) {
      this.$router.push(`/application-manager/${tab}/${this.$route.params.applicationId}`);
    },

    deleteApp() {
      const name = this.application_detail.name;

      this.$swal({
        title: 'Delete Application',
        html: `Are you sure to delete Application "<span style="font-family: Poppins-Medium; font-size: 18px;">${name}</span>"?`,
        type: 'question',
        showCancelButton: true,
        confirmButtonText: 'Delete',
        confirmButtonColor: '#D2232A',
        cancelButtonColor: '#D2232A',
        titleColor: '#D2232A',
      }).then(async (result) => {
        if (result.value) {
          const res = await this.actionDeleteApplication(this.application_detail.id);
          if (!res.error) this.$router.push('/application-manager');
        }
      });
    },

    backToV1() {
      this.$router.push(`/setting/application/${this.$route.params.applicationId}`);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/application-manager/detail/jAppManagerDetail.vue